import { configProviderChain } from './config-provider-chain';
import { defaultConfig } from './default-config';

export function getConfigValue<T extends keyof typeof defaultConfig>(
    key: T,
): (typeof defaultConfig)[T] {
    for (const provider of configProviderChain) {
        const value = provider(key);
        if (value !== undefined) {
            return value;
        }
    }
    return defaultConfig[key];
}
